const dateConverter = (monthsBack) => {
  var date = new Date()
  date.setMonth(date.getMonth() - monthsBack)
  return date.toISOString().split('T')[0]
}

export { dateConverter }
